import {
  getPosStorageByKey,
  updatePosStorageByKey,
  type PosAdminPageState,
} from "@/lib/pos/page-state";
import { useCallback, useState } from "react";

export function usePagePersistentState<PageState>(
  pageKey: keyof PosAdminPageState,
  defaultState: PageState
) {
  const [state, setState] = useState<PageState>(() =>
    getPosStorageByKey<PageState>(pageKey, defaultState)
  );

  const setPersistentState = useCallback(
    (value: React.SetStateAction<PageState>) => {
      setState((prev) => {
        const nextState =
          typeof value === "function"
            ? (value as (prev: PageState) => PageState)(prev)
            : value;

        updatePosStorageByKey<PageState>(pageKey, nextState);

        return nextState;
      });
    },
    [pageKey]
  );

  return [state, setPersistentState] as const;
}
